import { privateFetch, publicFetch } from "../libs/axios"
import {
  CreateStripePosPaymentIntentRequestType,
  CreateStripePosPaymentIntentResponseType,
  GetAllStripePosReadersResponseType,
  GetIntegrationRequestType,
  GetIntegrationResponseType,
  GetSqaureupLocationsResponseType,
  GetStripePosConnectionTokenResponseType,
  PreInstallResponseType,
  StripePosRegisterReaderRequestType,
  StripePosRegisterReaderResponseType,
  UninstallResponseType,
  UpdateSqaureupLocationRequestType,
} from "../types/IntegrationTypes"
import { jsonToQueryString } from "../utils/Common"

export const preInstall = async (integrationName: string) =>
  await privateFetch().post<PreInstallResponseType>(
    `/api/v1/integration/${integrationName}/pre-install`
  )

export const install = async (integrationProvider: string, body: Record<string, string | number>) =>
  await privateFetch().post<UninstallResponseType>(
    `/api/v1/integration/${integrationProvider}/install`,
    body
  )

export const uninstall = async (integrationProvider: string) =>
  await privateFetch().post<UninstallResponseType>(
    `/api/v1/integration/${integrationProvider}/uninstall`
  )

export const getIntegrations = async (
  { type, installed, is_installable }: GetIntegrationRequestType,
  isIntegratedPage?: boolean
) => {
  if (isIntegratedPage) {
    return await publicFetch().get<GetIntegrationResponseType>(
      `/api/v1/public/integration${jsonToQueryString({
        type,
        installed,
        is_installable,
      })}`
    )
  }
  return await privateFetch().get<GetIntegrationResponseType>(
    `/api/v1/integration${jsonToQueryString({
      type,
      installed,
      is_installable,
    })}`
  )
}

export const getSqaureupLocations = async (integrationId: string) =>
  await privateFetch().get<GetSqaureupLocationsResponseType>(
    `/api/v1/integration/squareup/${integrationId}/locations`
  )

export const updateSqaureupLocation = async (
  integrationId: string,
  body: UpdateSqaureupLocationRequestType
) =>
  await privateFetch().post<UninstallResponseType>(
    `/api/v1/integration/squareup/${integrationId}/locations`,
    body
  )

export const stripePosRegisterReader = async (
  integrationId: string,
  body: StripePosRegisterReaderRequestType
) =>
  await privateFetch().post<StripePosRegisterReaderResponseType>(
    `/api/v1/integration/stripepos/${integrationId}/readers`,
    body
  )

export const getAllStripePosReaders = async (integrationId: string) =>
  await privateFetch().get<GetAllStripePosReadersResponseType>(
    `/api/v1/integration/stripepos/${integrationId}/readers`
  )

export const setStripePosPrimaryReader = async (integrationId: string, readerId: string) =>
  await privateFetch().post<UninstallResponseType>(
    `/api/v1/integration/stripepos/${integrationId}/reader/${readerId}/default`
  )

export const removeStripePosReader = async (integrationId: string, readerId: string) =>
  await privateFetch().delete<UninstallResponseType>(
    `/api/v1/integration/stripepos/${integrationId}/readers/${readerId}`
  )

export const getStripePosConnectionToken = async (integrationId: string) =>
  await privateFetch().get<GetStripePosConnectionTokenResponseType>(
    `/api/v1/integration/stripepos/${integrationId}/connection-token`
  )

export const createStripePosPaymentIntent = async (
  integrationId: string,
  body: CreateStripePosPaymentIntentRequestType
) =>
  await privateFetch().post<CreateStripePosPaymentIntentResponseType>(
    `/api/v1/integration/stripepos/${integrationId}/intent`,
    body
  )
